/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PermissionRepresentationFromJSON, PermissionRepresentationToJSON, } from './';
export function AddPermissionsUserGroupRequestFromJSON(json) {
    return AddPermissionsUserGroupRequestFromJSONTyped(json, false);
}
export function AddPermissionsUserGroupRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        permissions: json['permissions'].map(PermissionRepresentationFromJSON),
    };
}
export function AddPermissionsUserGroupRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        permissions: value.permissions.map(PermissionRepresentationToJSON),
    };
}
